import { authRoles } from 'app/auth/authRoles';
import Loadable from 'app/components/Loadable';
import { lazy } from 'react';

const DeviceMeterAnalytics = Loadable(lazy(() => import('./DeviceMeterAnalytics')));
const deviceMeterRoutes = [
  { path: '/device-meter/default', element: <DeviceMeterAnalytics />, auth: authRoles.admin },
];
export default deviceMeterRoutes;
